import { defineMessages } from "react-intl";

const messages = defineMessages({
  label: {
    id: "p3eRUm",
    defaultMessage: "Preview",
    description: "indicator that feature is in preview mode",
  },
  tooltip: {
    id: "KGsaGO",
    defaultMessage:
      "This feature is in a preview state and can be subject to changes at later point",
    description: "tooltip",
  },
});

export default messages;
